import { Grid } from '@material-ui/core';
import { Dispatch, useState, VFC } from 'react';
import { useForm, UseFormReturn, FormProvider } from 'react-hook-form';
import { useHooks } from './useHooks';
import { useStyles } from './useStyles';
import { SiteProcessTextfield } from '../../input/ProcessTextfield';
import { SiteProcessSelectfield } from '../../input/ProcessSelectfield';
import { SiteProcessDatePicker } from '../../input/ProcessDatePicker';
import {
  DECIMAL_VALIDATION,
  validationMessage
} from '../../../../const/ProcessConst';
import { TAddSiteProcessForm } from '../../../../types/attendancManage';
import { BaseModal } from '../../../molecules/BaseModal';

export type TProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  constructId: number;
  setIsLoadingGantt: Dispatch<boolean>;
  parentSiteProcessId?: number;
  initialVisibleRange: any;
};

export const AttendanceAddModal: VFC<TProps> = props => {
  const {
    isOpen,
    setIsOpen,
    constructId,
    setIsLoadingGantt,
    parentSiteProcessId,
    initialVisibleRange
  } = props;
  const classes = useStyles();

  const methods: UseFormReturn<TAddSiteProcessForm> = useForm({
    reValidateMode: 'onSubmit'
  });
  const {
    handleSubmit,
    reset,
    formState: { errors }
  } = methods;

  const {
    cancelSubmit,
    submit,
    businessTypeList,
    employeeList,
    partnerList,
    endDate,
    handleChangeEndDatePicker
  } = useHooks({
    setIsOpen,
    constructId,
    reset,
    isOpen,
    setIsLoadingGantt,
    parentSiteProcessId,
    initialVisibleRange
  });

  const [selectBusinessType, setSelectBusinessType] = useState({
    label: '--',
    value: 0
  });

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={handleSubmit(submit, (erros: any) => {})}
      handleCancelSubmit={cancelSubmit}
      title={'新規人工追加'}
      buttonCaption={'追加する'}
      cancelButtonCaption={'キャンセル'}
    >
      <FormProvider {...methods}>
        {/* 種別 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>種別*</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <SiteProcessSelectfield
            name='business_type'
            listDatas={businessTypeList}
            className={`${classes.input} ${classes.gridItem}`}
            onChange={(e: any) => setSelectBusinessType(e)}
            required={true}
            error={errors?.business_type?.message != undefined}
            errorMessage={errors?.business_type?.message}
          />
        </Grid>
        {/* /種別 */}
        {/* 期間 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>期間*</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <div className={classes.leftAlignContainer}>
            <Grid container>
              <Grid item xs={7} md={5}>
                <div className={classes.itemMargin}>
                  <SiteProcessDatePicker
                    name='start_date'
                    label='開始日'
                    required={true}
                    fullWidth={true}
                    toDate={endDate}
                    errorMessage={errors?.start_date?.message}
                    className={classes.gridItem}
                    errorMessageStyle={{ display: 'none' }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={1}>
                <div className={classes.itemMargin} style={{ width: 20 }}>
                  <span className={classes.textStyle}>〜</span>
                </div>
              </Grid>
              <Grid item xs={7} md={5}>
                <div className={classes.itemMargin}>
                  <SiteProcessDatePicker
                    name='end_date'
                    label='終了日'
                    fullWidth={true}
                    onChange={handleChangeEndDatePicker}
                    className={classes.gridItem}
                  />
                </div>
              </Grid>
              {errors.start_date && (
                <Grid item xs={12}>
                  <div className={`${classes.helperText} ${classes.gridItem}`}>
                    {errors?.start_date?.message}
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
        {/* 担当者 */}
        {selectBusinessType.value == 1 && (
          <>
            <Grid item xs={10} md={3} className={classes.gridItem}>
              <label className={classes.label}>担当者*</label>
            </Grid>
            <Grid item xs={10} md={7}>
              <SiteProcessSelectfield
                name='user_id'
                listDatas={employeeList}
                className={`${classes.input} ${classes.gridItem}`}
                required={true}
                error={errors?.user_id?.message != undefined}
                errorMessage={errors?.user_id?.message}
              />
            </Grid>
          </>
        )}
        {/* /担当者 */}
        {/* 企業名 */}
        {selectBusinessType.value == 2 && (
          <>
            <Grid item xs={10} md={3} className={classes.gridItem}>
              <label className={classes.label}>企業名*</label>
            </Grid>
            <Grid item xs={10} md={7}>
              <SiteProcessSelectfield
                name='partner_id'
                listDatas={partnerList}
                className={`${classes.input} ${classes.gridItem}`}
                required={true}
                error={errors?.partner_id?.message != undefined}
                errorMessage={errors?.partner_id?.message}
              />
            </Grid>
          </>
        )}
        {/* /企業名 */}

        {/* 計画人工 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>計画人工*</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <SiteProcessTextfield
            name='artificial'
            className={`${classes.input} ${classes.gridItem}`}
            pattern={DECIMAL_VALIDATION}
            patternMessage={validationMessage.decimal}
            max={9999.99}
            required={true}
            errorMessage={errors?.artificial?.message}
          />
        </Grid>
        {/* /計画人工 */}
      </FormProvider>
    </BaseModal>
  );
};
